/*eslint-disable */
import root from '@/_helpers/roots';
import axios from 'axios';
let getPlanListApiUrl = root.getPlanListApiUrl.link;
let createProductApiUrl = root.createProductApiUrl.link;
let createPlanApiUrl = root.createPlanApiUrl.link;
let getAllSubscriptionProductApiUrl = root.getAllSubscriptionProductApiUrl.link;
let deactivatePlanApiUrl = root.deactivatePlanApiUrl.link;
let activatePlanApiUrl = root.activatePlanApiUrl.link;
let allPlanClearApiUrl = root.allPlanClearApiUrl.link;
let allProductClearApiUrl = root.allProductClearApiUrl.link;
import Vue from 'vue'
export default {
  state: {
    getSubscriptionPlanListState:{},
    getSubscriptionProductListState:{}
  },
  mutations: {
    getSubscriptionPlanListMutation(state, value) {
      Vue.set(state, 'getSubscriptionPlanListState', value);
    },
    getSubscriptionProductListMutation(state, value) {
      Vue.set(state, 'getSubscriptionProductListState', value);
    },
  },
  actions: {
    // All Product Clear Func
    allProductClearFunc(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(allProductClearApiUrl).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // All Plan Clear Func
    allPlanClearFunc(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(allPlanClearApiUrl).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Deactivate Plan Func
    activatePlanFunc(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(activatePlanApiUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Deactivate Plan Func
    deactivatePlanFunc(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(deactivatePlanApiUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Create Subscruption Plan Info Func
    createSubscriptionPlanInfoFunc(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(createPlanApiUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Create Subscruption Product Info Func
    createSubscriptionProductInfoFunc(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(createProductApiUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Plan List
    getSubscriptionPlanListFunc(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(getPlanListApiUrl).then(res => {
              context.commit('getSubscriptionPlanListMutation', res);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Subscription Product List
    getSubscriptionProductListFunc(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(getAllSubscriptionProductApiUrl).then(res => {
              context.commit('getSubscriptionProductListMutation', res);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
  },
  getters: {
    getSubscriptionPlanListGetters: state => state.getSubscriptionPlanListState,
    getSubscriptionProductListGetters: state => state.getSubscriptionProductListState
  }
}